<template>
  <client-only>
    <v-text-field
      v-model="model"
      :label="fieldLabel"
      solo
      type="text"
      :rules="fieldRequired ? nameRules : noRule"
      rounded
      :prepend-inner-icon="fieldIconName"
      :required="false"
      outlined
      dense
    ></v-text-field>
  </client-only>
</template>

<script>
import { nameRules } from '@/lib/rules.js';

export default {
  props: {
    fieldLabel: {
      type: String,
    },
    fieldIconName: {
      type: String,
      required: false,
    },
    fieldRequired: {
      type: Boolean,
      required: false,
      default: true,
    },
    currentValue: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      fieldValue: '',
      nameRules,
      noRule: [],
    };
  },

  computed: {
    model: {
      get() {
        return this.currentValue ? this.currentValue : '';
      },
      set(val) {
        this.fieldValue = val;
      },
    },
  },

  methods: {},

  watch: {
    fieldValue() {
      // Emit this information to the parents component
      this.$emit('child-field', this.fieldValue);
    },
  },
};
</script>